module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms-of-conditions"
  }, [_vm._v("\n  I have read, understand, and accept Calvert Impact Capital's\n  "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://calvertimpact.org/terms-of-use"
    }
  }, [_vm._v("\n    Terms of Use\n  ")]), _vm._v(",\n  "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.calvertimpactcapital.org/privacy#privacy"
    }
  }, [_vm._v("\n    Privacy Policy\n  ")]), _vm._v(", and\n  "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.calvertimpactcapital.org/prospectus"
    }
  }, [_vm._v("\n    Community Investment Note Prospectus\n  ")]), _vm._v(", and our payment partner Dwolla's\n  "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.dwolla.com/legal/tos/?whitelabel"
    }
  }, [_vm._v("\n    Terms of Service\n  ")]), _vm._v(" and\n  "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.dwolla.com/legal/privacy?whitelabel"
    }
  }, [_vm._v("\n  Privacy Policy\n  ")]), _vm._v(".\n  "), _c('br'), _c('br'), _vm._v("\n  I further agree that any interest check I receive for an amount less than $20.00\n  that remains uncashed 365 days after issuance will be donated to Calvert Impact Capital\n  and I will receive a donation receipt for that amount.\n  I will be notified of the uncashed check three times prior to the donation.\n  "), _c('br'), _c('br'), _vm._v(" "), (!_vm.hideStateDisclosures) ? [_vm._m(0), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n    For Tennessee Residents Only: I also acknowledge that I have 1. a gross\n    annual income of at least $70,000 and a net worth of at least $70,000, or\n    a net worth of at least $250,000, and 2. that I am not investing more than\n    10% of my personal net worth (excluding my primary residence, home\n    furnishings, and automobiles).\n    "), _c('br'), _c('br'), _vm._v("\n    For Washington State Residents Only: I also acknowledge that I am not\n    investing more than 10% of my personal net worth, or joint net worth with\n    my spouse or spousal equivalent, in Community Investment Notes. For this\n    purpose, my net worth excludes the value of my primary residence and its\n    furnishing, automobiles, and loans associated with them.\n  ")] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('u', [_vm._v("For Pennsylvania Residents")]), _vm._v(": Please note your right of refusal\n      within two days of investing as described in the prospectus on\n      "), _c('u', [_vm._v("page iv")]), _vm._v(".\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c64b14b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TermsOfConditions.vue
// module id = 2202
// module chunks = 1